import { ref } from 'vue'
import { BILLING_PAGE_TAB_VALUE } from '@/stores/tabs'
const orderType = ref(null)

const activeStep = ref(0)
const maxOpenedTab = ref(0)

const setState = (metadata) => {
  const { currentTab, maxOpenedTab: maxTab } = metadata ?? {}

  // Only move the "furthest reached" marker to a real, non-negative tab index.
  // A missing/NaN/-1 value here must not corrupt it (it gates tab clicking).
  const parsedMaxTab = Number(maxTab)
  if (!Number.isNaN(parsedMaxTab) && parsedMaxTab >= 0) {
    maxOpenedTab.value = parsedMaxTab
  }

  // A missing/invalid current tab must NOT snap the wizard back to the first
  // tab — leave the user on the tab they are on.
  if (currentTab === undefined || currentTab === null || currentTab === '') {
    return
  }

  const parsedCurrentTab = Number(currentTab)
  if (Number.isNaN(parsedCurrentTab)) return

  // BILLING_PAGE_TAB_VALUE (-1) is the "advance to billing" sentinel handled by
  // the order view's router redirect. Don't collapse it back to the first tab.
  if (parsedCurrentTab === BILLING_PAGE_TAB_VALUE) return

  activeStep.value = parsedCurrentTab < 0 ? 0 : parsedCurrentTab
}

const clearState = () => {
  activeStep.value = 0
  maxOpenedTab.value = 0
}

export { activeStep, maxOpenedTab, orderType, setState, clearState }
